import React, { useState, useEffect } from "react";
import moment from "moment";
import toast from "react-hot-toast";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import PageHeader from "@core/components/pageHeader";
import ArchiveProgramList from "views/pages/todaysprogram/ArchiveList";
import AddTodayProgram from "views/pages/todaysprogram/AddTodayProgram";
import APICall from "network/APICall";
import EndPoints from "network/Endpoints";
import Utility from "@core/helper/utility";
import { useSelector } from "react-redux";
import Loader from "@core/helper/Loader";

const ArchiveList = () => {
  const [openModal, setOpenModal] = useState(false);
  const [type, setType] = useState("");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [programtList, setProgramList] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [updateData, setUpdateData] = useState(null);
  const [totalRecord, setTotalRecord] = useState("");
  const [permission, setPermission] = useState({});
  const { userData } = useSelector((state) => state.auth);
  const [role, setRole] = useState("");
  const handleDeleteModal = (id) => {
    if (id) {
      const payload = { id };
      APICall("delete", payload, EndPoints.deleteProgram)
        .then((response) => {
          const { isError, message } = response.data;
          if (response.status === 200 && !isError) {
            toast.success(message);
            const filter = programtList.filter((o) => o.id !== id);
            setProgramList(filter);
            fetchProgramList();
          }
        })
        .catch((error) => {
          return error;
        });
    }
    setDeleteOpen(!deleteOpen);
  };

  const handleOpen = (type, id) => {
    setOpenModal(!openModal);
    setSearchText("");
    setType(type);
    if (id) {
      const findList = programtList.find((o) => o.id === id);
      setUpdateData(findList);
    }
  };
  useEffect(() => {
    if (userData.data.user.role === "2") {
      const archive = Utility.getUserData({
        datastore: userData,
        activePath: "/program",
      });
      setPermission(archive[1]);
    } else {
      setPermission({});
    }

    setRole(userData.data.user.role);
  }, [userData]);
  useEffect(() => {
    fetchProgramList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText, pageSize, pageNumber]);

  const fetchProgramList = () => {
    Loader.isLoading(true);
    const currentDate = moment(new Date()).format("yyyy-MM-DD");

    const payload = {
      pageNo: pageNumber + 1,
      limit: pageSize,
      orderBy: "DESC",
      searchText: searchText,
      date: currentDate,
      isFutureProgram: false,
    };
    APICall("post", payload, EndPoints.getProgramList)
      .then((response) => {
        const { results, totalCount } = response.data.data;
        if (response.status === 200 && results) {
          setProgramList(results);
          setTotalRecord(totalCount);
        } else {
          setProgramList([]);
        }
      })
      .catch((error) => {
        return error;
      })
      .finally(() => {
        Loader.isLoading(false);
      });
  };

  const submitProgram = () => {
    fetchProgramList();
  };

  return (
    <Grid container spacing={4}>
      <PageHeader
        title={
          <Typography variant="body1" sx={{ fontSize: "1.3rem !important" }}>
            Program
          </Typography>
        }
      />
      {((permission.view && role === "2") || role === "1") && (
        <Grid item xs={12}>
          <ArchiveProgramList
            handleDeleteModal={handleDeleteModal}
            deleteOpen={deleteOpen}
            handleOpen={handleOpen}
            programtList={programtList}
            pageSize={pageSize}
            setPageSize={setPageSize}
            searchText={searchText}
            setSearchText={setSearchText}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            totalRecord={totalRecord}
            permission={permission}
            role={role}
          />
        </Grid>
      )}
      {type !== undefined && (
        <AddTodayProgram
          open={openModal}
          toggle={handleOpen}
          type={type}
          heading={type === "edit" ? "Update Program" : ""}
          onSubmitProgram={submitProgram}
          updateData={updateData}
          permission={permission}
          role={role}
        />
      )}
    </Grid>
  );
};

export default ArchiveList;
